let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bM4Ly")).then(() => parcelRequire('ffvAu'));